"use client";

import { useSession } from "next-auth/react";
import { useEffect, useRef } from "react";

function TokenRefresh() {
  const { update, status } = useSession();
  const isRefreshing = useRef(false);

  useEffect(() => {
    if (status !== "authenticated") return;
    const interval = setInterval(
      async () => {
        if (isRefreshing.current) return;
        isRefreshing.current = true;
        try {
          await update();
        } finally {
          isRefreshing.current = false;
        }
      },
      2 * 60 * 1000
    );
    return () => clearInterval(interval);
  }, [status, update]);

  return null;
}

export default TokenRefresh;
